module.exports = __webpack_public_path__ + "Flama-Basic.woff2?0c8485f8a1beebb5222d60d6501b38d1";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Basic.woff2
// module id = 893
// module chunks = 0